import React, { ReactElement, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export interface IInfoSection {
  icon: ReactElement;
  children: ReactNode;
}

export const InfoSection: React.FC<IInfoSection> = ({
  icon,
  children,
}): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.85,
        backgroundColor: 'grey.100',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: 'text.secondary',
          '& .MuiSvgIcon-root': {
            fontSize: '1rem',
          },
        }}
      >
        {icon}
      </Box>
      <Typography variant="body2" color="text.primary" fontSize="0.8rem">
        {children}
      </Typography>
    </Box>
  );
};
